import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/api.service';
import { Location } from '@angular/common';

interface User {
  id: number;
  name: string;
  email: string;
  image: string;
  selected: boolean;
}

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})

export class UserListComponent {
  all_user: User[] = [];
  tenant_user: User[] = []; // New array for tenant-specific users

  constructor(private route: ActivatedRoute, private apiService: ApiService, private location: Location) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const tenantId = params.get('tenant_id');
      alert(tenantId);
      this.fetchUserData();
      this.fetchTenantUserData(tenantId); // Call the new function with tenantId
      // Use the userId for your logic
    });
  }

  fetchUserData() {
    this.apiService.getAlluser().subscribe(
      (response) => {
        console.log('Data from API:', response);
        response.data.map((users, i) => {
          let user = {
            id: users.id,
            name: users.name,
            email: users.email,
            image: 'path/to/bikrant-image.jpg',
            selected: false
          };
          this.all_user.push(user);
          console.log(user);
        });
        this.updateSelectedUsers(); // Update selected users after fetching all users
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  fetchTenantUserData(tenantId: string) {
    this.apiService.getTenantuser(tenantId).subscribe(
      (response) => {
        console.log('Tenant Data from API:', response);
        response.data.map((users, i) => {
          let user = {
            id: users.id,
            name: users.name,
            email: users.email,
            image: 'path/to/bikrant-image.jpg',
            selected: false
          };
          this.tenant_user.push(user); // Push to tenant_user array
          console.log(user);
        });
        this.updateSelectedUsers(); // Update selected users after fetching tenant users
      },
      (error) => {
        console.error('Error fetching tenant data:', error);
      }
    );
  }

  updateSelectedUsers() {
    if (this.all_user.length && this.tenant_user.length) {
      this.all_user.forEach(user => {
        if (this.tenant_user.some(tenantUser => tenantUser.id === user.id)) {
          user.selected = true;
        }
      });
    }
  }

  // userss = [
  //   {
  //     name: 'Bikrant Giri',
  //     email: 'l3ikrant@gmail.com',
  //     image: 'path/to/bikrant-image.jpg',
  //     selected: false
  //   },
  //   {
  //     name: 'Saroj Rai',
  //     email: 'aesaroj16@gmail.com',
  //     image: 'path/to/saroj-image.jpg',
  //     selected: false
  //   },
  //   {
  //     name: 'Nishon Tandukar',
  //     email: 'nishon.tan@gmail.com',
  //     image: 'path/to/nishon-image.jpg',
  //     selected: false
  //   },
  //   {
  //     name: 'Amulya Acharya',
  //     email: 'awemulya@gmail.com',
  //     image: 'path/to/amulya-image.jpg',
  //     selected: true
  //   },
  //   {
  //     name: 'Sanip Rijal',
  //     email: 'saneprijal@gmail.com',
  //     image: 'path/to/sanip-image.jpg',
  //     selected: true
  //   },
  //   {
  //     name: 'Aashish Baidya',
  //     email: 'aashish.baidya.c3@gmail.com',
  //     image: 'path/to/aashish-image.jpg',
  //     selected: false
  //   }
  // ];

  toggleSelect(user) {
    user.selected = !user.selected;
  }

  onSubmit() {
    const selectedUsers = this.all_user.filter(user => user.selected);
    console.log('Selected Users:', selectedUsers);

    if (selectedUsers.length === 0) {
      console.log('No users selected');
      return;
    }

    const tenantId = this.route.snapshot.paramMap.get('tenant_id');
    
    // Create payload with array of user IDs
    const payload = {
      user_ids: selectedUsers.map(user => user.id),
      tenant_id: tenantId
    };

    console.log('Bulk add payload:', payload);

    // Single API call with all selected users
    this.apiService.addTenantuser(payload).subscribe(
      (response) => {
        console.log('Users added to tenant:', response);
        this.location.back();
      },
      (error) => {
        console.error('Error adding users to tenant:', error);
        // Optionally show error message to user
        if (error.status === 429) {
          console.error('Rate limit exceeded. Please try again later.');
        }
      }
    );
  }

  goBack() {
    this.location.back();
  }
}